// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__nkxPH","spinner":"Spinner_spinner__T7KNK","spin":"Spinner_spin__3ZQgb"};